<template>
  <div
    class="apple-pay-button"
    :class="{ 'cta--loading': this.isLoading }"
    @click.prevent="onClick"
  >
    <div class="apple-pay-button__inner-container">
      <span class="apple-pay-button__text" v-t="'checkout.payment.applepay.pay_with'"></span>
      <span class="apple-pay-button__logo"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplePayButton',
  props: {
    onClick: { type: Function, required: true },
    isLoading: { type: Boolean, required: true, default: false },
  },
}
</script>

<style lang="scss" scoped>
.apple-pay-button {
  cursor: pointer;
  background-color: $color-black;
  color: white;
  text-align: center;
  display: inline-block;
  line-height: 1;
  padding: 20px 25px;
  position: relative;
  transition: border $transition-time-fast, color $transition-time-fast,
    background $transition-time-fast;
  width: 100%;

  @media ($mq-large) {
    font-size: $font-size-larger;
    padding: 20px 35px;
    margin-top: 5px;
  }

  &:hover,
  &:focus {
    opacity: 0.8;
  }

  &:after {
    border-bottom-color: $color-cta-primary-border;
  }
}

@supports (-webkit-appearance: -apple-pay-button) {
  .apple-pay-button__inner-container {
    display: inline-block;
    -webkit-appearance: -apple-pay-button;
    -apple-pay-button-type: buy;
    -apple-pay-button-style: black;
  }

  .apple-pay-button__inner-container > * {
    display: none;
  }
}

@supports not (-webkit-appearance: -apple-pay-button) {
  .apple-pay-button {
    &__inner-container {
      --apple-pay-scale: 1; /* (height / 32) */
      display: inline-flex;
      justify-content: center;
      border-radius: 5px;
      padding: 0px;
      box-sizing: border-box;
      min-width: 200px;
      font-size: 12px;
      min-height: 32px;
      max-height: 64px;
      background-color: black;
      color: white;
    }

    &__logo {
      background-image: -webkit-named-image(apple-pay-logo-white);
      background-color: black;
      width: calc(35px * var(--scale));
      height: 100%;
      background-size: 100% 60%;
      background-repeat: no-repeat;
      background-position: 0 50%;
      margin-left: calc(2px * var(--apple-pay-scale));
      border: none;
    }

    &__text {
      font-family: -apple-system;
      font-size: calc(1em * var(--apple-pay-scale));
      font-weight: 300;
      align-self: center;
      margin-right: calc(2px * var(--apple-pay-scale));
    }
  }
}
</style>
